//
// TODO:
//
// Remove this file once the home page is launched on SSR:

import React, { useEffect } from "react";
import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";
import { useDispatch } from "react-redux";

import { LEGACY_SET_ICONS } from "js/reducers/marketing";
import IconLandingPage from "./index";

const GET_ICONS_ICONSPAGE = gql`
    query heroIcons {
        heroIcons {
            iconLandingPage {
                items {
                    id
                    thumbnails {
                        thumbnail84
                    }
                    title
                    url
                }
                totalCount
            }
        }
    }
`;

export default () => {
    const { data } = useQuery(GET_ICONS_ICONSPAGE);
    const dispatch = useDispatch();

    useEffect(() => {
        if (
            data &&
            data.heroIcons &&
            data.heroIcons.iconLandingPage &&
            data.heroIcons.iconLandingPage.items
        ) {
            dispatch({
                type: LEGACY_SET_ICONS,
                icons: data.heroIcons.iconLandingPage.items
            });
        }
    }, [data]);

    return <IconLandingPage />;
};
